import {ReactComponent} from '../app'
import {Spin} from "antd"

export default class ReservationPage extends ReactComponent {

  state = {
    loading: false
  }

  componentDidMount() {

    void this.updateState({loading: true})

    const height = Math.floor(window.innerHeight * 0.75)
    const rootStyles = getComputedStyle(document.documentElement)
    const primaryColor = rootStyles.getPropertyValue('--_primary-hex').trim()
    const secondaryColor = rootStyles.getPropertyValue('--_secondary-hex').trim()
    const fontColor = rootStyles.getPropertyValue('--_font-hex').trim()

    window._hors = [
      ['eid', 'hydra-3218c66a-2f70-44a4-8e8e-530c5ab8c3ad'],
      ['tagid', 'hors-hydra-3218c66a-2f70-44a4-8e8e-530c5ab8c3ad'],
      ['width', '100%'],
      ['height', height],
      ['foregroundColor', fontColor],
      ['backgroundColor', ''],
      ['linkColor', ''],
      ['errorColor', ''],
      ['primaryButtonForegroundColor', primaryColor],
      ['primaryButtonBackgroundColor', secondaryColor],
      ['secondaryButtonForegroundColor', ''],
      ['secondaryButtonBackgroundColor', ''],
    ];

    (function (d, t) {
      var e = d.createElement(t), s = d.getElementsByTagName(t)[0]
      e.src = 'https://reservation.dish.co/widget.js'
      s.parentNode.insertBefore(e, s)
    }(document, 'script'))

    setTimeout(() => {
      void this.updateState({loading: false})
    },1000)
  }

  render() {
    return (
      <section className="container centered full-height">
        <h1 className="main-title">Rezervace</h1>
        <Spin spinning={this.state.loading} size="large" fullscreen/>
          <div id="hors-hydra-3218c66a-2f70-44a4-8e8e-530c5ab8c3ad"></div>

      </section>
    )
  }
}